module.exports = __webpack_public_path__ + "static/media/pranav-profile.97d1dc2e.jpg";